import { Component, Input } from '@angular/core';
import { FiltroCompilabileType } from '../filtro-compilabile.component';
import { FormGroup, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: ".opzioni-filtro-compilabile",
    templateUrl: "./opzioni-filtro-compilabile.html"
})
export class OpzioniFiltroCompilabile {

    @Input('campoFiltroIN') set campoFiltroIN(campo: FiltroCompilabileType) {
        this.campoMapped = _.cloneDeep(campo);
        this.campoMapped.formGroup = null;
        this.initFormGroup();
    }
    campoMapped: FiltroCompilabileType;

    valueHasChanged: boolean = false;

    constructor(
        private modal: NzModalRef
    ) { }

    initFormGroup() {
        this.campoMapped.formGroup = new FormGroup({});//nuovo formGroup per evitare rogne
        this.campoMapped.formGroup.addControl(
            this.campoMapped.controlName,
            new FormControl((this.campoMapped as any).value ? (this.campoMapped as any).value : null)
        );
    }

    changeValue() {
        this.valueHasChanged = true;
    }


    chiudi() {
        let res: {
            id: string,
            value: any
        } = null;
        if (this.valueHasChanged) {
            res = {
                id: null,
                value: null
            };
            res.id = (this.campoMapped as any).id;
            res.value = this.campoMapped.controlType !== 'selezione-multipla' ? this.campoMapped.formGroup.get(this.campoMapped.controlName).value : this.campoMapped.items;
        }
        this.modal.destroy(res);
    }
}